<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>商品类型</span>
        </div>
        <div class="conf">
          <el-form-item label="" prop="productType">
            <div class="ft-12">
              <el-radio-group v-model="self_form.productType">
                <el-radio :label="1" border> 实物商品 </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>类目选择</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类:" prop="categoryIds">
            <div class="category ft-12">
              <category-input
                ref="cinput"
                v-model="self_form.categoryIds"
                :baseItemId="baseItemId" 
                :platform="platform"
              />
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品标题" prop="title">
            <el-input
              type="text"
              placeholder="填写商品名称与关键字"
              v-model="self_form.title"
              maxlength="60"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="商品描述" prop="subTitle">
            <el-input
              type="text"
              placeholder="填写商品描述"
              v-model="self_form.subTitle"
              maxlength="18"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="类目属性">
            <CategoryProps
              ref="cateprops"
              v-model="self_form.attrs"
              :categoryIds="self_form.categoryIds"
            />
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>图文信息</span>
        </div>
        <div class="conf">
          <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
            <GroupImagesList :baseItemId="baseItemId" :specifications="specifications" :hideImgs="['mainImages34']" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
          </el-form-item>
          <el-form-item label="商品主图" prop="headImgs">
            <div class="imgs-wrp">
              <div class="ft-12">拖动可调整顺序<BatchEditImages v-model="self_form.headImgs" refName="headImgs" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
              <MutiImgUpload
                ref="headImgs"
                v-model="self_form.headImgs"
                :limitSize="10 * 1024 * 1024"
                :size="300"
                :limitNums="9"
                limitSuffix=".jpg,.png,.jpeg"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <p class="tips ft-12">
              请使用jpg/png/jpeg格式,单图大小需小于10M
            </p>
          </el-form-item>
          <el-form-item label="商品详情图" prop="descInfo">
            <div><BatchEditImages v-model="self_form.descInfo" refName="descInfo" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
            <div class="imgs-wrp">
              <MutiImgUpload
                ref="descInfo"
                v-model="self_form.descInfo"
                :mainImgNums="0"
                :limitNums="20"
                :size="300"
                :limitSize="10 * 1024 * 1024"
                limitSuffix=".jpg,.jpeg,.png"
              />
              
            </div>
          </el-form-item>
          <el-form-item>
            <p class="tips ft-12">
              最多上传20张图片,单图大小需小于10M
            </p>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>销售信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品规格:" prop="skuAttrs">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification
              v-model="specifications"
              :changeToBase="changeToBase"
              :isPlatform="true"
              :platform="platform"
              imgLimitSuffix=".jpg"
            />
          </el-form-item>
          <el-form-item label="规格明细:" prop="skuAttrsDetail">
            <FormItemSkuList
              :isWxxd="true"
              :baseItemId="baseItemId"
              :specifications="specifications"
              skuSpecificationsKey="skuSpecifications"
              :imgOnlyPreview="skuImgOnlyPreview"
              :tableCols="skuTableCols"
              v-model="skuList"
              @fieldChanged="validPage"
            />
            <template v-if="specificationsValidResult !== true">
              <div class="el-form-item__error">{{specificationsValidResult}}</div>
            </template>
          </el-form-item>
        </div>
      </section>
      <!-- 运费模板 -->
      <section>
        <div class="title ft-12">
          <span>更多设置</span>
        </div>
        <div class="conf">
          <el-form-item label="运费模板">
            <el-row v-if="shopList.length > 0">
              <el-col
                v-for="shop in shopList"
                :key="shop.id"
                :span="12"
                class="set-ship"
              >
                <el-image
                  :src="shop.icon"
                  style="width: 26px; height: 26px; border-radius: 50%"
                ></el-image>
                <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                  <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                </el-tooltip>
                <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
                <el-select
                  v-model="shipsValue[shop.id]"
                  placeholder="请选择运费模板"
                  :value-key="String(shop.id)"
                  clearable
                  @visible-change="changeSelect(shop.id, shop.userId)"
                >
                  <el-option
                    v-for="ship in shipsTemplate[shop.id]"
                    :key="ship.id"
                    :label="ship.name"
                    :value="ship.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <span v-else class="no-shops">暂无平台店铺</span>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item
            label="上架设置"
            :rules="[
              { required: true, message: '请选择上架设置' },
            ]"
            prop="isOnshelf"
          >
            <el-radio-group v-model="self_form.isOnshelf">
              <el-radio :label="1">立即上架</el-radio>
              <el-radio :label="2">放入草稿箱</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </section>
    </el-form>
  </div>
</template>
<script>
import "@/assets/css/prod.scss";
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryProps from "./CategoryProps.vue";
import CategoryInput from "../PlatformCategoryInput/index.vue";

import RULES, { validateSkuStock } from "./rules.js";
import { validateSkuPrice } from "../DdianInfoForm/rules";

import { specification_mixin } from "../FormItemSpecification";
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';

import {
  getDistributionConfig,
  getWeixxdTemplateList,
} from "@servers/prod/conf/index.js";
import { cloneDeep } from 'lodash';
import { mapGetters } from "vuex";

export default {
  mixins: [specification_mixin, validateMixin, shopListMixin],
  inject: {
    isGroupPuhuo: { default: false },
    selectShopList: { default: () => [] },
  },
  provide: {
    platform: "wxxd",
  },
  components: {
    MutiImgUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    CategoryProps,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    shopsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      self_form: {},
      rules: RULES(this),
      skuTableCols: [
        {
          prop: "salePrice",
          attrs: { label: "售卖价" },
          input: { type: "number", validator: validateSkuPrice },
          previewPrice: ['taskCenter','previewPublish'].includes(this.openSource) ? false : true, previewPriceType: 'sales'
        },
        {
          prop: "marketPrice",
          attrs: { label: "市场价", noRequired: true },
          input: { type: "number" },
          previewPrice: ['taskCenter','previewPublish'].includes(this.openSource) ? false : true, previewPriceType: 'market'
        },
        { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true } ,unvisible:JSON.parse(localStorage.getItem('_origin_form'))?.isDistribution == 0? true : false },
        {
          prop: "stockNum",
          attrs: { label: "库存" },
          input: { type: "number", validator: validateSkuStock },
        },
        { prop: "skuCode", attrs: { label: "商家编码" } },
      ],
      showGroupImages: true,
      skuSpecificationsKey: "skuSpecifications",
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      shipsTemplate: null, // 运费模板列表
      shipsValue: null, // 运费模板值
      templateConfigMap: null, // 初始值
      originalTemplateConfig: null,
      isWxxd: true,
      platform: "wxxd",
      shopList: "",
    };
  },
  computed: {
    ...mapGetters(['shops_getCategoryPropShopId', 'get_AllShops_BySource']),
  },
  watch: {
    form: {
      handler(v) {
        if (v.templateConfig && v.templateConfig.length) {
            this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        if (v.skuList) {
          v.skuList = v.skuList.map((item) => {
            const _skuid = item[this.skuSpecificationsKey]
              .map((sp) => sp.valueKey)
              .join("-");
            return {
              ...item,
              _skuid,
            };
          });
        }
        if (v.specifications && v.specifications.length) {
          this.specifications = JSON.parse(JSON.stringify(v.specifications))
        }
        this.$set(this, "self_form", {
          ...v,
          isOnshelf: this.self_form.isOnshelf || v.isOnshelf
        });
        this.$nextTick(() => {
          // this.$refs.form.validate();
          this.validPage();
        });
      },
      immediate: true,
    },
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    method_getFormData(cb) {
      return new Promise(async (resolve, reject) => {
        this.validPage().then(async (valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resolve(false)
            return;
          }
          let attrData = await this.$refs.cateprops.method_getData();
          if (!attrData) {
            this.$message.error("请完善类目属性");
            resolve(false);
            return;
          }
          const [specifications, skuList] = this.getSpecificationData()
          let _formdata = JSON.parse(JSON.stringify(this.self_form))
          _formdata.specifications = JSON.parse(JSON.stringify(specifications))
          _formdata.skuList = skuList.map(item => ({...item, imageUrl: item[this.skuSpecificationsKey][0].imageUrl}))
          _formdata.attrs = attrData;
          _formdata.templateConfig = (() => {
            let current = JSON.parse(this.handleTemplateConfig());
            current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
            return JSON.stringify(current);
          })();
          _formdata.shopId = this.shops_getCategoryPropShopId('wxxd') || 157803
          resolve(_formdata)
        });
      });
    },
    updateCategoryIds(ids) {
      this.self_form.categoryIds = ids;
    },
    handleTemplateConfig() {
      const arr = [];
      Object.keys(this.shipsValue).forEach((key) => {
        this.shipsTemplate[key].forEach((item) => {
          if (item.id == this.shipsValue[key]) {
            const channel = this.shopList.find(shop => shop.id == key)?.channel
            arr.push({
              shopId: key,
              templateId: item.id,
              templateName: item.name,
              channel
            });
          }
        });
      });
      return JSON.stringify(arr);
    },
    // 处理微信小店 templateConfig
    initTemplateConfig(templateList = []) {
      const ships = {};
      this.shopList.forEach((shop) => {
        ships[shop.id] = "";
      });
      const templateConfigMap = {};
      this.self_form.templateConfig = this.self_form.templateConfig
        ? this.self_form.templateConfig
        : [];
      this.self_form.templateConfig.forEach((item) => {
        templateConfigMap[item.shopId] = {
          templateId: item.templateId,
          templateName: item.templateName,
        };
      });
      templateList.forEach((item) => {
        if (!templateConfigMap[item.shopId]) {
          templateConfigMap[item.shopId] = {
            templateId: item.templateId,
            templateName: item.templateName,
          };
        }
      });
      this.templateConfigMap = templateConfigMap;
      Object.keys(templateConfigMap).forEach((key) => {
        ships[key] = templateConfigMap[key].templateId;
      });
      this.shipsValue = ships;
      this.initShipsTemplate(templateConfigMap);
    },
    // 处理每个店铺下拉框
    initShipsTemplate(templateConfigMap) {
      const shipsTemplate = {};
      this.shopList.forEach((shop) => {
        shipsTemplate[shop.id] = [];
      });
      Object.keys(templateConfigMap).forEach((key) => {
        shipsTemplate[key] = [
          {
            id: templateConfigMap[key].templateId || "",
            name: templateConfigMap[key].templateName || "",
          },
        ];
      });
      this.shipsTemplate = shipsTemplate;
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: "wxxd" });
      if (this.isGroupPuhuo) {
        this.shopList = this.shopsList;
      } else {
        const selectList = this.selectShopList();
        if(selectList && selectList.length) {
          this.shopList = selectList.filter(item => item.source === 'wxxd');
        } else {
          const shopList = this.get_AllShops_BySource('wxxd');
          // 如果是重新铺货或者已经有对应的店铺进来，直接显示对应的店铺
          if(this.rowData.isFromLog) {
            this.shopList = shopList.filter(item => item.id == this.rowData.shopId);
          }else{
            this.shopList = shopList;
          }
        }
      }
      if(this.openSource === 'shopGoods'){
          this.shopList = this.shopList.filter(item => item.id == this.form.shopId)
      }
      // 上架设置
      this.self_form.isOnshelf = this.form.isOnshelf ? this.form.isOnshelf : (res?.shelfState || 1);
      // 运费模板
      this.initTemplateConfig(res?.templateList || []);
    },
    // 获取模板
    async getTemplateList(userId) {
      const list = await getWeixxdTemplateList({
        userId: userId,
      });
      if (list) {
        return list.map((ship) => {
          return {
            name: ship.templateName,
            id: ship.templateId,
          };
        });
      }
      return [];
    },
    async changeSelect(shopId, userId) {
      const list = await this.getTemplateList(userId);
      const idx = list.findIndex((item) => item.id === this.shipsValue[shopId]);
      if (idx === -1) {
        this.shipsValue[shopId] = "";
      }
      this.$set(this.shipsTemplate, shopId, list);
    },
    useGroupImages(data, type) {
      const {mainImages=[], detailImages=[], speImages=[]} = data
      let pic = [], description = [];
      if(type === 'add') {
        pic = [...this.self_form.headImgs].filter(Boolean)
        description = [...this.self_form.descInfo]
      }
      if(mainImages.length) {
        this.self_form.headImgs = [...pic, ...mainImages].filter(Boolean).slice(0, 9)
      }
      if(detailImages.length) {
        this.self_form.descInfo = [...description, ...detailImages].filter(Boolean).slice(0, 50)
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specValue.imageUrl) {
            return;
          }
          
          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specValue.value);
          if (matchedImage) {
            specValue.imageUrl = matchedImage.imgUrl;
          }
        });
      }
    },
    getGroupImagesList (list){
      this.showGroupImages = !!list?.length
    },
    editGroupImages(){
      this.changeToBase('openGroupImgs')
    },
  },
  mounted() {
    this.getConf();
  },
};
</script>

<style lang="scss" scope>
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>